// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_type_a/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_type_a: ModuleSchema = {
  "id": "core_rattan_type_a",
  "uniqueId": "B3D_RTA01",
  "createdAt": "2026-10-26T06:34:25.165Z",
  "updatedAt": "2026-10-30T10:37:26.864Z",
  "label": "Rattan Type A",
  "description": "One-layer Type A interlocking rattan strand with a 3 mm structural base pad.",
  "category": "rattan",
  "tags": [
    "core-rattan-type-a"
  ],
  "sliders": [
    {
      "key": "width",
      "label": "Form Width",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "depth",
      "label": "Form Depth",
      "min": 10,
      "max": 200,
      "default": 130,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "height",
      "label": "Form Height",
      "min": 12,
      "max": 120,
      "default": 40,
      "step": 2,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "cornerRadius",
      "label": "Corner Radius",
      "min": 1,
      "max": 60,
      "default": 19.5,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "topFilletRadius",
      "label": "Top Fillet Radius",
      "min": 0,
      "max": 20,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bottomFilletRadius",
      "label": "Bottom Fillet Radius",
      "min": 0,
      "max": 20,
      "default": 0,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bellyRadius",
      "label": "Belly Radius",
      "min": 0,
      "max": 25,
      "default": 8,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "bellyTension",
      "label": "Belly Tension",
      "min": 0,
      "max": 1,
      "default": 0.35,
      "step": 0.05,
      "unit": "ratio",
      "enabled": true,
      "visible": true
    },
    {
      "key": "middleRadius",
      "label": "Middle Radius",
      "min": 0,
      "max": 25,
      "default": 20,
      "step": 0.5,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch",
      "min": 4,
      "max": 24,
      "default": 6,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude",
      "min": 0.5,
      "max": 5,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "faceCycles",
      "label": "Odd Cycles Per Face",
      "min": 3,
      "max": 15,
      "default": 7,
      "step": 2,
      "unit": "cycles",
      "enabled": true,
      "visible": true
    },
    {
      "key": "layerOverlap",
      "label": "Structural Layer Overlap",
      "min": 0,
      "max": 1.6,
      "default": 0.3,
      "step": 0.05,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness",
      "min": 0.2,
      "max": 10,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "strandHeight",
      "label": "Strand Height",
      "min": 0.4,
      "max": 10,
      "default": 2,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "padThickness",
      "label": "Structural Pad Thickness",
      "min": 0.2,
      "max": 10,
      "default": 3,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseHeight",
      "label": "Shade-Tier Base Height",
      "min": 4,
      "max": 30,
      "default": 12,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseInset",
      "label": "Shade-Tier Seat Inset",
      "min": 2,
      "max": 40,
      "default": 12,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseFlare",
      "label": "Shade-Tier Foot Flare",
      "min": 0,
      "max": 20,
      "default": 5,
      "step": 1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableBottomWatermark",
      "label": "Bottom Brand Watermark (Z=0)",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    },
    {
      "key": "enableCavityWatermark",
      "label": "Anti-Theft Surface Brand Watermark",
      "min": 0,
      "max": 1,
      "default": 1,
      "step": 1,
      "unit": "",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shade_tier_and_wave_form",
      "label": "Flared Shade-Tier Base and Type A Woven Surface",
      "default": "#64748b",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "main_body",
      "label": "Core Rattan Type A",
      "name": "Core Rattan Type A",
      "color": "#64748b",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "shade_tier_and_wave_form",
          "label": "Flared Shade-Tier Base and Type A Woven Surface",
          "name": "Flared Shade-Tier Base and Type A Woven Surface",
          "groupId": 0,
          "colorKey": "shade_tier_and_wave_form",
          "defaultColor": "#64748b",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Assembly"
    }
  ]
};
